import { Component, OnDestroy } from '@angular/core'
import { PipelineType, TsneParameters, UmapParameters } from '../../../shared/model/jobs'
import { HttpErrorResponse } from '@angular/common/http'
import { JobApiService } from '../../../shared/services/job-api.service'
import { ToasterService } from '../../../shared/services/toaster.service'
import {
    selectCaseMarkers,
    selectLoadedSegObjectPropertyMaps,
} from '../../../state/case/case.selectors'
import { Store } from '@ngrx/store'
import { PropertySummary, SegObjectPropertyMap } from '../../../state/case/case.state'
import { closeJobSelectionDialog } from '../../../shared/utils/job-selection-dialog-utils'
import { Subject, takeUntil } from 'rxjs'

@Component({
    selector: 'app-clustering-selection',
    templateUrl: './clustering-selection.component.html',
    styleUrls: ['./clustering-selection.component.scss'],
})
export class ClusteringSelectionComponent implements OnDestroy {
    readonly PipelineTypeEnum = PipelineType

    selectedPipeline: PipelineType.tsneClustering | PipelineType.umapClustering | null = null

    readonly clusteringMarkers$ = this.store.select(selectCaseMarkers)

    private clusteringParams: TsneParameters | UmapParameters | null = null
    private loadedIntensityMaps: SegObjectPropertyMap[] = []
    private readonly destroy$ = new Subject<void>()

    get clusteringParamsSet(): boolean {
        return this.clusteringParams !== null
    }

    constructor(
        private readonly jobApi: JobApiService,
        private readonly toaster: ToasterService,
        readonly store: Store
    ) {
        this.store
            .select(selectLoadedSegObjectPropertyMaps)
            .pipe(takeUntil(this.destroy$))
            .subscribe(maps => {
                this.loadedIntensityMaps = maps
            })
    }

    ngOnDestroy(): void {
        this.destroy$.next()
        this.destroy$.complete()
    }

    confirmClusteringParameters(params: TsneParameters | UmapParameters): void {
        this.clusteringParams = params
    }

    abortMarkerSelection(): void {
        this.clusteringParams = null
    }

    selectMarkerLayers(eventData: { name: string; markers: PropertySummary[] }): void {
        if (this.clusteringParams === null) return
        if (this.loadedIntensityMaps.length === 0) {
            this.toaster.httpError(
                new HttpErrorResponse({ error: 'Select an intensity map' }),
                ''
            )
            return
        }

        this.jobApi
            .startClusteringJob({
                ...this.clusteringParams,
                name: eventData.name,
                markers: eventData.markers.map(marker => marker.name),
                seg_object_property_maps: this.loadedIntensityMaps,
            })
            .subscribe({
                next: () => closeJobSelectionDialog(),
                error: (err: HttpErrorResponse) => {
                    this.toaster.httpError(err, 'Error starting job')
                },
            })
    }
}
